import { useEffect, useRef } from "react";

import { useLogout } from "@/hooks/use-auth";

export function LogoutPage() {
  const logout = useLogout();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;
    logout();
  }, [logout]);

  return (
    <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
  );
}
